import { useBrowseProductEntitlementApi } from '@aibees/shared/api';

export function useEntitlementActive() {
  const { data } = useBrowseProductEntitlementApi();

  const featuredProduct = data?.products;
  const paidProduct = featuredProduct?.find(
    (p) => p.name?.toLowerCase() === 'standard'
  );

  const freeProduct = featuredProduct?.find(
    (p) => p.name?.toLowerCase() === 'free'
  );

  const isActiveInPaid = (ids: string[]) => {
    return ids.some((id) => paidProduct?.id === id);
  };

  const isActiveInFree = (ids: string[]) => {
    return ids.some((id) => freeProduct?.id === id);
  };

  return { isActiveInPaid, isActiveInFree };
}
